import React from "react";
import { Link } from "react-router-dom";
import { useScreenSizes } from "../WindowSizeUtils";

const Footer: React.FC = () => {
  const { isMobileScreen, isSmallScreen } = useScreenSizes();
  return (
    <div>
      <div style={{ height: "100px" }}></div>
      <footer
        style={{
          color: "white",
          backgroundColor: "#691C70",
          padding: "20px",
          width: "calc(100% - 40px)",
          height: isMobileScreen ? "auto" : "350px",
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
        }}
      >
        <div className="iGEM TSUKUBA">
          <p
            style={{
              fontFamily: "Roboto",
              fontWeight: "600",
              fontSize: isMobileScreen
                ? "16pt"
                : isSmallScreen
                  ? "24pt"
                  : "30pt",
              marginTop: "0px",
              marginBottom: "0px",
              marginLeft: "30px",
            }}
          >
            <Link to="/" style={{ color: "#FFFFFF", textDecoration: "none" }}>
              iGEM TSUKUBA
            </Link>
          </p>
        </div>
        <div
          className="content"
          style={{
            display: isMobileScreen ? "block" : "flex",
            fontFamily: "Noto Sans JP",
            fontSize: isMobileScreen ? "10pt" : isSmallScreen ? "12pt" : "14pt",
            padding: 0,
          }}
        >
          <div
            className="left-side"
            style={{ marginLeft: isMobileScreen ? "30px" : "50px" }}
          >
            <p style={{ margin: "20px 0 0 0" }}>
              <strong>私たちについて</strong>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/about/about_symbio"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                合成生物学とは
              </Link>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/about/about_iGEM"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                iGEMとは
              </Link>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/about/about_iGEM_TSUKUBA"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                iGEM TSUKUBAとは
              </Link>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/about/project"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                研究内容
              </Link>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/about/members"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                メンバー
              </Link>
            </p>
          </div>
          <div className="right-side" style={{ marginLeft: "30px" }}>
            <p style={{ margin: "20px 0 0 0" }}>
              <strong>これまでの活動</strong>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/activity/news"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                ニュース
              </Link>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/activity/log"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                活動実績
              </Link>
            </p>
            <p style={{ margin: "20px 0 0 0" }}>
              <strong>
                <Link
                  to="/recruitment"
                  style={{ color: "#FFFFFF", textDecoration: "none" }}
                >
                  メンバー募集
                </Link>
              </strong>
            </p>
            <p style={{ margin: "20px 0 0 0" }}>
              <strong>賛同される方へ</strong>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/sponsorship"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                ご協賛のお願い
              </Link>
            </p>
            <p style={{ margin: "5px 0 5px 20px" }}>
              <Link
                to="/education_request"
                style={{ color: "#FFFFFF", textDecoration: "none" }}
              >
                教育活動先の募集
              </Link>
            </p>
          </div>
          <div
            className="logo-and-social"
            style={{ marginTop: "20px", alignItems: "center" }}
          >
            <a
              href="https://x.com/Igem_Tsukuba"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/components/footer/logo-white.png`}
                alt="iGEM TSUKUBA Logo"
                style={{
                  width: isMobileScreen
                    ? "30px"
                    : isSmallScreen
                      ? "50px"
                      : "70px",
                  marginLeft: "60px",
                }}
              />
            </a>
            <a
              href="https://www.instagram.com/igem_tsukuba/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/components/footer/Instagram_Glyph_White.png`}
                alt="Instagram"
                style={{
                  width: isMobileScreen
                    ? "32px"
                    : isSmallScreen
                      ? "55px"
                      : "70px",
                  height: isMobileScreen
                    ? "32px"
                    : isSmallScreen
                      ? "55px"
                      : "70px",
                  marginLeft: "40px",
                }}
              />
            </a>
            <a
              href="mailto:igemtsukuba24@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/components/footer/icon_mail.png`}
                alt="Mail"
                style={{
                  width: isMobileScreen
                    ? "35px"
                    : isSmallScreen
                      ? "60px"
                      : "70px",
                  height: isMobileScreen
                    ? "35px"
                    : isSmallScreen
                      ? "60px"
                      : "70px",
                  marginLeft: "40px",
                }}
              />
            </a>
            <a
              href="https://www.sportsanzen.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}/components/footer/Spo_An_banner.png`}
                alt="Sports Anzen banner"
                style={{
                  width: isMobileScreen
                    ? "200px"
                    : isSmallScreen
                      ? "200px"
                      : "280px",
                  marginTop: "30px",
                  marginLeft: "40px",
                }}
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
